import React, { Component, PureComponent } from 'react';
import { DropdownList } from 'react-widgets';
import { SocialMedia } from '../../core/api/models';
import ErrorMessage from '../text/ErrorMessage';

interface ErrorObject {
  name: string;
  message: string;
}

interface Props {
  placeholder?: string;
  onChange: (val: SocialMedia[]) => void;
  value?: SocialMedia[];
  className?: string;
  isEdit?: boolean;
  onUpdate?: (val: SocialMedia[]) => void;
  canEditCustomerSocialMediaDetails?: boolean;
  allData?: SocialMedia[];
  errors?: ErrorObject[];
}

interface OptionProps {
  name: string;
  value: string;
}

interface SingleProps {
  onChange: (val: SocialMedia) => void;
  value: SocialMedia;
  isEdit?: boolean;
  onRemove: () => void;
  socilaMediaOption: OptionProps[];
  canEditCustomerSocialMediaDetails?: boolean;
  error?: ErrorObject
}

interface State {
  socialMedia: SocialMedia[];
}

const options = [
  { name: 'Facebook', value: 'Facebook' },
  { name: 'Instagram', value: 'Instagram' },
  { name: 'Twitter', value: 'Twitter' },
  { name: 'LinkedIn', value: 'LinkedIn' },
];

class SingleInput extends PureComponent<SingleProps> {
  setType = (type: { name: string; value: string }) => {
    const { value } = this.props;
    value.name = type.value;
    this.props.onChange(value);
  };

  setProfile = (event: { target: { value: string } }) => {
    const { value } = this.props;
    value.socialId = event.target.value;
    this.props.onChange(value);
  };

  render() {
    return (
      <div className="input-group mb-2">
        <div className="col-3 p-0">
          <DropdownList
            value={this.props?.value?.name}
            defaultValue={this.props?.value?.name}
            data={this.props.socilaMediaOption}
            textField={'name'}
            valueField={'value'}
            placeholder={'Select'}
            onChange={this.setType}
            disabled={!this.props.canEditCustomerSocialMediaDetails}
          />
        </div>
        <input
          type="text"
          placeholder="Social Id"
          className="font-sm font-weight-semibold form-control border-left-0"
          value={this.props.value.socialId}
          name="socialId"
          id="socialId"
          onChange={this.setProfile}
          disabled={!this.props.canEditCustomerSocialMediaDetails}
        />
        {this.props.isEdit && this.props.canEditCustomerSocialMediaDetails && (
          <i
          onClick={this.props.onRemove}
          className="icon-bin-fill cursor-pointer align-self-center font-lg text-gray-700"
          ></i>
        )}
        <div>
          {this.props.error?.message && <ErrorMessage>{this.props.error?.message}</ErrorMessage>}
        </div>
      </div>
    );
  }
}

// tslint:disable-next-line: max-classes-per-file
class CustomerSocialMedia extends Component<Props, State> {
  static defaultProps = {
    value: '',
  };

  state = {
    socialMedia:
      this.props.value && this.props.value.length > 0
        ? this.props.value
        : [
            {
              socialId: '',
              name: 'Facebook',
            },
          ],
  };

  addMoreComponent = () => {
    const { socialMedia } = this.state;
    socialMedia.push({
      socialId: '',
      name: '',
    });

    this.setState({ socialMedia });
  };

  handleOnChange = (profile: SocialMedia, index: number) => {
    const { onChange } = this.props;
    const { socialMedia } = this.state;

    socialMedia[index] = profile;
    this.setState({ socialMedia });
    onChange(socialMedia);
  };

  handleOnRemove = (index: number) => {
    const { onChange } = this.props;
    const { socialMedia } = this.state;
    const alreadyExists = this.props.allData?.find(
      (x) => x.name === socialMedia[index]?.name
    );

    socialMedia.splice(index, 1);
    this.setState({ socialMedia });
    onChange(socialMedia);

    if (this.props.isEdit && this.props.onUpdate && alreadyExists) {
      this.props.onUpdate(socialMedia);
    }
  };

  renderInputs = () => {
    const { socialMedia } = this.state;

    const inputs = [];
    const selectedOptions = socialMedia?.map((x) => x.name);

    if (socialMedia && socialMedia.length) {
      for (let i = 0; i < socialMedia.length; i++) {
        if (
          (!this.props.canEditCustomerSocialMediaDetails &&
            socialMedia[i].socialId) ||
          this.props.canEditCustomerSocialMediaDetails
        ) {
          inputs.push(
            <SingleInput
              onChange={(value: SocialMedia) => this.handleOnChange(value, i)}
              value={socialMedia[i]}
              isEdit={this.props.isEdit}
              onRemove={() => this.handleOnRemove(i)}
              socilaMediaOption={options.filter(
                (x) => !selectedOptions.includes(x.name)
              )}
              canEditCustomerSocialMediaDetails={
                this.props.canEditCustomerSocialMediaDetails
              }
              error={this.props.errors?.find(item=>item.name===socialMedia[i]?.name)}
            />
          );
        }
      }
    }

    return inputs;
  };

  render() {
    return (
      <>
        {this.renderInputs()}
        <div className="w-100"></div>
        {this.props.canEditCustomerSocialMediaDetails && (
          <button
            type="button"
            className="btn btn-link font-sm p-0 font-weight-semibold"
            onClick={this.addMoreComponent}
          >
            + add one more
          </button>
        )}
      </>
    );
  }
}

export default CustomerSocialMedia;
